(function(angular){
	'use strict';

	angular
		.module('settingsModule')
		.controller('ManageSettingsController', [
			'$scope',
			'$window',
			ManageSettingsFunction
		]);

	function ManageSettingsFunction(
		$scope,
		$window
	){
		var manageSettings = this;

		manageSettings.openConfirmationModal = function() {
			$scope.$broadcast('confirmationModal:open');
		};
		manageSettings.handleDelete = function() {
			$window.document.getElementById('deleteInvestmentEntityForm').submit();
		};
	}
})(window.angular);